import { all, fork } from 'redux-saga/effects';
import bootingSaga from './booting';
import configSaga from './config';
import sessionSaga from './session';
import playlistsSaga from './playlists';

export default function* musicSaga() {
  yield all([
    fork(sessionSaga),
    fork(configSaga),
    fork(bootingSaga),
    fork(playlistsSaga),
  ]);
}
